export default "/institutions/rico.svg";